<template>
<dialog-layout>
  <div>
    <div class="media-unit-image-slider">
      <a href="#" @click.prevent="cycleActiveBlockImageObjectPosition">
        <ri :n="imageObjectPosition == 'center' ? 'focus-2-line' : `layout-${imageObjectPosition}-2-line`" />
      </a>
      <input type="range" min="0" max="100" step="1"
             v-model="activeBlockMediaWidth">
      <a href="#" @click.prevent="activeBlockHeightIsLocked = !activeBlockHeightIsLocked">
        <ri v-if="activeBlockHeightIsLocked" n="lock-line" />
        <ri v-else n="lock-unlock-line" />
      </a>    
    </div>

    <div class="media-unit-image-slider">
      <input type="range" min="-1000" max="1000" step="1"
             v-model="backgroundImageOffsetX">
    </div>
    
    <button type="button" class="btn btn-secondary" @click="$emit('close', { props: { 'content-styles': writeStyleString(contentStyles), styles: writeStyleString(styles) }})">Close</button>

  </div>
</dialog-layout>
</template>

<script>
import DialogMediaUnitManipulator from './DialogMediaUnitManipulator.vue';

export default {
  name: 'DialogMediaUnitManipulatorWithBackgroundKnobs',
  extends: DialogMediaUnitManipulator,
  watch: {
    backgroundImageOffsetX (val) {
      this.updateStyles('--image-offset-x', val);
    },
  },
  data () {
    const backgroundImageOffsetX = this.component.styles['--image-offset-x'];
    
    return {
      backgroundImageOffsetX,
    };
  },
}
</script>

<style>
.media-unit-image-slider {
  border-radius: 150px;
  top: 85vh;
  background: #eee;
  padding: 1rem;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1rem 3rem rgb(0 0 0 / 38%) !important;
}

.media-unit-image-slider a {
  text-decoration: none;
}
.media-unit-image-slider i {
  color: black;
}
</style>
